var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMenu = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 37 37",
  style: {
    enableBackground: "new 0 0 37 37"
  },
  xmlSpace: "preserve",
  className: "icon icon--menu",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.8 16.8c0-.1-.1-.2-.1-.3.2-.2.4-.5.6-.7 2-2.1 4.1-4.2 6.1-6.4.7-.7.7-1.5.2-2-.5-.6-1.3-.6-2 .1-2.1 2.1-4.1 4.3-6.2 6.4l-.7.7c-.1-1.5.3-2.7 1-3.6 1.4-1.8 2.8-3.5 4.3-5.2.6-.7.7-1.4.2-2-.5-.5-1.2-.6-1.8-.1-2.3 2.1-4.3 4.3-5.6 7.2-.8 1.7-1.1 3.5-.3 5.4.1.2 0 .5-.1.6-1 1.1-2.1 2.3-3.2 3.4-1.3-1.3-2.4-2.6-3.6-3.8-.4-.4-.6-.7-.3-1.4.2-.5.3-1.2.4-1.8.1-3.7-2.4-7.7-5.7-9.1C5.5 3 1.8 4.9.9 8.6c-.7 2.9.4 5.3 2.4 7.2 2.5 2.3 5.2 3.6 8.6 2.3.1-.1.4 0 .5 0 1.4 1.4 2.7 2.8 4.1 4.2-1.7 1.8-3.4 3.6-5.1 5.3-1.1 1.3-2.3 2.4-3.4 3.6-.7.7-.5 1.8.2 2.2.6.3 1.2.1 1.7-.4 1.8-1.9 3.6-3.8 5.4-5.6 1-1 1.9-2 2.9-3.1 2.8 2.9 5.5 5.7 8.2 8.6.8.8 1.6.9 2.1.3.6-.6.5-1.4-.4-2.2-1.2-1.3-2.4-2.5-3.6-3.8-1.5-1.6-3-3.1-4.5-4.7 1.1-1.1 2.2-2.2 3.2-3.3.1-.1.5-.2.7-.1 1.2.5 2.4.6 3.6.2 2.5-.7 4.5-2.3 6.3-4.1.7-.7 1.4-1.5 2.1-2.3.5-.6.4-1.4-.2-1.8-.6-.4-1.1-.4-1.7.1-.2.2-.3.4-.5.6-1.7 1.8-3.4 3.6-5.7 4.7-.5 0-1.3.1-2 .3z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconMenu.8bc368ee.svg";
export { ForwardRef as ReactComponent };